import {
  Inject,
  Injectable,
  PLATFORM_ID,
  Renderer2,
  RendererFactory2,
} from '@angular/core';
import { DOCUMENT, isPlatformServer } from '@angular/common';
import { AccessabilityFontSize } from '../models/accessibility-font-sizes.model';

@Injectable({
  providedIn: 'root',
})
export class FontSizeService {
  private readonly renderer!: Renderer2;
  private readonly fontSizeStoreKey = 'font-option';

  constructor(
    @Inject(DOCUMENT) private document: Document,
    @Inject(PLATFORM_ID) private platformId: string,
    rendererFactory: RendererFactory2
  ) {
    this.renderer = rendererFactory.createRenderer(null, null);
  }

  updateSize(fontSize: AccessabilityFontSize) {
    if (isPlatformServer(this.platformId)) {
      return;
    }

    localStorage.setItem(this.fontSizeStoreKey, fontSize);
    const rootHTMLElement = this.document.getElementsByTagName('html')[0];
    this.renderer.setAttribute(rootHTMLElement, 'class', fontSize);
  }

  getCurretSize() {
    if (isPlatformServer(this.platformId)) {
      return AccessabilityFontSize.normal;
    }

    return (
      <AccessabilityFontSize>localStorage.getItem(this.fontSizeStoreKey) ||
      AccessabilityFontSize.normal
    );
  }
}
